<template>
  <div class="new_vip">
    <div class="content">
      <div class="page_title">会员信息</div>
      <div class="form">
        <el-form :model="formData" ref="formData" label-width="100px" :rules="rules">
          <!-- <el-form-item label="会员卡号" class="half_width" prop="card_num">
            <el-input v-model="formData.card_num" class="input_box"></el-input>
          </el-form-item> -->
          <el-form-item label="头像" v-if="addType">
            <el-upload
              ref="upload"
              class="avatar-uploader"
              action="https://www.58zltc.com/api/Upload/uploads/"
              :show-file-list="false"
              accept="image/*"
              :on-success="handleAvatarSuccess"
              :data="imgdata"
              :on-change="changefile"
              :auto-upload="false"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="会员姓名" class="half_width" prop="name" v-if="addType">
            <el-input v-model="formData.name" class="input_box"></el-input>
          </el-form-item>
          <el-form-item label="会员姓名" class="half_width" prop="name" v-if="!addType">
            <el-input v-model="formData.real_name" class="input_box"></el-input>
          </el-form-item>
          <el-form-item label="性别" class="half_width">
            <el-radio-group v-model="formData.sex">
              <el-radio :label="1">先生</el-radio>
              <el-radio :label="2">女士</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号码" class="half_width" prop="mobile">
            <el-input v-model="formData.mobile" class="input_box"></el-input>
          </el-form-item>
          <el-form-item label="会员等级" class="half_width" prop="level_card_id">
            <el-select v-model="formData.level_card_id" placeholder="请选择" class="input_box">
              <el-option
                v-for="item in level_options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="卡面号" class="half_width">
            <el-input v-model="formData.face_num" class="input_box"></el-input>
          </el-form-item> -->
          <el-form-item label="所属店铺" class="half_width" prop="store_id" v-if="addType">
            <el-select v-model="formData.store_id" placeholder="请选择" class="input_box">
              <el-option
                v-for="item in store_options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="账户余额" class="half_width">
            <el-input v-model="formData.balance" class="input_box"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="积分数量" class="half_width">
            <el-input v-model="formData.point" class="input_box"></el-input>
          </el-form-item>
          <el-form-item label="售卡金额" class="half_width">
            <el-input v-model="formData.money" class="input_box"></el-input>
          </el-form-item> -->
          <el-form-item label="提成员工" class="half_width" v-if="addType">
            <el-select v-model="formData.employee_id" placeholder="请选择" class="input_box">
              <el-option
                v-for="item in emp_options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员生日" class="half_width">
            <el-date-picker
              class="input_box"
              v-model="formData.birthday"
              type="date"
              placeholder="请选择"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="邮箱" class="half_width">
            <el-input v-model="formData.mail" class="input_box"></el-input>
          </el-form-item> -->
          <el-form-item label="推荐人卡号" class="half_width" v-if="addType">
            <el-input v-model="formData.reference_card" class="input_box"></el-input>
          </el-form-item>
          <!-- <el-form-item label="身份证" class="half_width">
            <el-input v-model="formData.id_card_num" class="input_box"></el-input>
          </el-form-item> -->
          <el-form-item label="车牌号" class="half_width" v-if="addType">
            <el-input v-model="formData.device" class="input_box"></el-input>
          </el-form-item>
          <!-- <el-form-item label="地址" class="half_width">
            <el-input v-model="formData.address" class="input_box"></el-input>
          </el-form-item> -->
          <el-form-item label="备注" class="half_width" v-if="addType">
            <el-input v-model="formData.detail_address" type="textarea" class="input_box"></el-input>
          </el-form-item>
          <el-form-item class="save_button">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button @click="goback()" v-if="addType">返回</el-button>
            <el-button @click="close()" v-if="!addType">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { storeSelect } from "@/api/employee"
import { vipList,employeeOptions,vipOpenCard,vipUserEdit } from "@/api/vip"
export default {
  props:{
    type: {
      type: String,
      default: "add"
    },
    editData:{
      type: Object,
      default: () => {}
    }
  },
  watch:{
    editData: {
      handler(newval) {
        console.log(newval);
        if(newval !== undefined){
          this.formData = Object.assign({},newval );
          this.addType = false;
        }
      },
      deep: true,
      immediate: true
    },
    type(val){
      if(val == "edit"){
        this.addType = false;
      }
    }
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      formData: {},
      imageUrl: "", //上传的图片地址
      imgdata: {}, //上传图片附加信息
      level_options: [], //会员等级选项
      store_options: [], //店铺选项
      emp_options: [], //员工选项
      rules: {
        card_num: [ { required: true, message: "请输入会员卡号", trigger: "submit" } ],
        name: [ { required: true, message: "请输入会员姓名", trigger: "submit" } ],
        mobile: [ { required: true, message: "请输入手机号", trigger: "submit" } ],
        level_card_id: [ { required: true, message: "请选择会员等级", trigger: "submit" } ],
        store_id: [ { required: true, message: "请选择所属店铺", trigger: "submit" } ],
      },
      addType: true, //新增/编辑
    }
  },
  mounted(){
    this.init();
    this.reset();
  },
  methods:{
    // 初始化 获取选项数据
    init(){
      this.formData = {
        sex: 1,
      }
      var data = {
        token:this.token,
        app_id:this.app_id
      }
      storeSelect(data).then(res=>{ 
        if(res.code == 200){
          this.store_options = res.data;
          this.loading = false;
        }else{
          this.$message({
            type: "error",
            message: "获取门店列表失败，请刷新重试"
          })
        }
      })
      vipList(data).then(res=>{
        if(res.code == 200){
          res.data.forEach(item => {
            this.level_options.push({id: item.id,name: item.name});
          })
        }else{
          this.$message({
            type: "error",
            message: "获取会员等级列表失败，请刷新重试"
          })
        }
      })
      employeeOptions(data).then(res=>{
        if(res.code == 200){
          this.emp_options = res.data;
        }else{
          this.$message({
            type: "error",
            message: "获取员工列表失败，请刷新重试"
          })
        }
      })
    },
    reset(){
      if(this.type == "edit"){
        this.addType = false;
        this.formData = Object.assign({},this.editData)
      }
    },
    // 图片上传
    // 文件选取的时候调用
    changefile(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      console.log(file, fileList);
      this.imgdata = {
        token: this.token,
        image: file.raw,
        type: "1",
        file_group: "1"
      };
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.formData.headimgurl = res.data.url;
      this.save();
    },
    // 提交保存
    submit(){
      if(this.imageUrl != ""){
        this.$refs.upload.submit();
      }else{
        this.save();
      }
    },
    save(){
      var data = Object.assign({},this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      console.log(data);
      // return false;
      if(this.addType){
        vipOpenCard(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type: "success",
              message: "保存成功！"
            })
            this.goback();
          }else{
            this.$message({
              type: "error",
              message: res.msg
            })
          }
        })
      }else{
        data.grade = data.level_card_id;
        vipUserEdit(data).then(res => {
          if(res.code == 200){
            this.$message({
              type: "success",
              message: "保存成功！"
            })
            this.close(1);
          }else{
            this.$message({
              type: "error",
              message: res.msg
            })
          }
        })
      }
    },
    goback(){
      this.$router.go(-1);
    },
    close(i){
      this.$emit('close');
      if(i == 1){
        this.$emit('refresh');
      }
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.el-upload-list--picture-card .el-upload-list__item {
  height: 104px;
  width: 104px;
}
.el-upload--picture-card {
  height: 104px;
  width: 104px;
  line-height: 100px;
}
</style>
<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content{
    background: #fff;
    padding: 25px;
    .page_title{
      font-size:16px;
      font-weight:500;
    }
    .form{
      margin-top:24px;
      // 图片上传
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 70px;
        height: 70px;
        line-height: 70px;
        text-align: center;
      }
      .avatar {
        width: 70px;
        height: 70px;
        display: block;
      }
      .half_width{
        width: 50%;
        display: inline-block;
        .input_box{
          width: 60%;
        }
      }
      .save_button{
        margin-top:30px;
      }
    }
  }
}
</style>